@if (state.activeSyllabus) {
  <ion-button
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="menu"
    fill="clear"
    class="top-panel-button w-full min-w-0"
    [class.active]="menuTrigger.menuOpen"
    (contextmenu)="$event.preventDefault(); navigateToCoursesSettings()"
  >
    <div class="flex min-w-0 items-center gap-2">
      @if (state.activeCourse?.icon; as icon) {
        <div class="flex w-[36px] flex-shrink-0 items-center justify-center">
          <dojo-icon [icon]="icon" [size]="26" />
        </div>
      }
      <span class="min-w-0 flex-1 truncate font-bold">{{ state.activeCourse?.shortLabel }}</span>
    </div>
  </ion-button>
}

<mat-menu #menu="matMenu" class="custom-mat-menu wide-width">
  <ng-template matMenuContent>
    <div class="flex flex-col">
      <div class="flex items-center px-4 pb-3 pt-4 md:border-b md:border-neutral-200 md:p-4">
        <h3 class="text-md text-secondary font-semibold">
          {{
            (state.activeCourse ? 'my_program_courses' : 'my_courses')
              | transloco: { program: state.activeCourse?.program_short_name ?? '' }
          }}
        </h3>
      </div>

      <div class="flex flex-col gap-3 px-3 pb-4 md:p-3">
        @for (course of state.courses; track course.compositeId) {
          <button
            class="course-button bg-neutral-0 flex w-full cursor-pointer items-start gap-2 text-left transition-colors duration-100"
            [class.active-course]="course.compositeId === state.activeCourse?.compositeId"
            (click)="onCourseSelected(course)"
          >
            <div class="z-1 flex min-w-0 flex-1 flex-col gap-0.5">
              <span
                class="text-sm font-medium"
                [ngClass]="course.compositeId === state.activeCourse?.compositeId ? 'text-sky-500' : 'text-disabled'"
              >
                {{ course.short_name }}
              </span>
              <span
                class="text-md font-medium"
                [ngClass]="
                  course.compositeId === state.activeCourse?.compositeId
                    ? 'text-sky-600 dark:text-sky-400'
                    : 'text-primary'
                "
              >
                {{ course.longLabel }}
              </span>
            </div>
            @if (course.compositeId === state.activeCourse?.compositeId) {
              <dojo-icon icon="check" [size]="16" class="z-1 shrink-0 self-center text-sky-500" />
            }
          </button>
        }
      </div>

      <div class="border-t border-neutral-200 p-4">
        <dojo-button [routerLink]="['/', 'settings', 'courses']">
          {{ 'manage_courses' | transloco }}
        </dojo-button>
      </div>
    </div>
  </ng-template>
</mat-menu>
